const ratingConfig = {
  RATINGS_LIST: [
    {
      value: 1,
      imageName: 'angry-face_1f621.png'
    },
    {
      value: 2,
      imageName: 'sad-face_2639.png'
    },
    {
      value: 3,
      imageName: 'neutral-face_1f610.png'
    },
    {
      value: 4,
      imageName: 'smiling-face_1f600.png'
    },
    {
      value: 5,
      imageName: 'star-face_1f929.png'
    }
  ],
  // Time in milliseconds before displaying the rating panel
  DISPLAY_PANEL_DELAY: {
    END_CONVERSATION: 2000 // 5 seconds
  },
  HIDE_PANEL_DELAY: 5000, // milliseconds
  MAX_FEEDBACK_LENGTH: 250
}

export default ratingConfig
